import { startClusteringReqPending, startClusteringReqRejected, startClusteringReqResolved } from 'tabs/topQuestions/lib/question_clusters_line_chart/questionClustersLineChartActions'
import { PRIVATE_BASE_URL } from 'configs'

import { BeginClusteringResponse, ClusteringStatus, ClusteringStatusResponse } from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusTypes'
import { updateIsTraining } from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusActions'
import { updateActiveClusteringId } from 'tabs/topQuestions/lib/top_questions_config/clusteringConfigurationActions'

export const sendStartClusteringChartData = (
  botId: number,
  minTimestampSeconds: number,
  maxTimestampSeconds: number,
) => {
  return async dispatch => {
    dispatch(startClusteringReqPending())
    try {
      const url = `${PRIVATE_BASE_URL}/top-questions/begin-clustering`
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({
          botId: botId,
          configuration: {
            startPeriod: minTimestampSeconds,
            endPeriod: maxTimestampSeconds,
          },
        }),
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      })
      if (response.status == 200) {
        const data = (await response.json()) as BeginClusteringResponse
        dispatch(updateIsTraining(data.clusteringId, ClusteringStatus.PENDING))
        dispatch(updateActiveClusteringId(data.clusteringId))
        dispatch(startClusteringReqResolved(data))
      } else {
        dispatch(startClusteringReqRejected())
      }
    } catch (error) {
      dispatch(startClusteringReqRejected())
    }
  }
}

export const checkIfClustering = (botId: number,
                                  clusteringExecutionId: string) => {
  return async dispatch => {
    const urlParams = new URLSearchParams()
    urlParams.append('clusteringExecId', clusteringExecutionId)
    const url = `${PRIVATE_BASE_URL}/bot/${botId}/top-questions/clustering-status?` + urlParams.toString()

    const response = await fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
    })
    if (response.status == 200) {
      const data = await response.json() as ClusteringStatusResponse
      dispatch(updateIsTraining(data.clusteringExecutionId, data.clusteringStatus))
      if (data.clusteringStatus === 'RESOLVED') {
        dispatch(updateActiveClusteringId(data.clusteringExecutionId))
      }
    }
  }
}
